/* global FormUtils */
(function () {
    const state = {
        ajaxHandlersBound: false,
        captchaSubmitHandlerBound: false,
        licenceClickBound: false,
        offerClickBound: false,
        licenceConditionClickBound: false,
        quickLocationsClickBound: false,
    };
    const buyerBlock = document?.querySelector('.order__buyer-block');
    if (buyerBlock) {
        const phoneInput = buyerBlock.querySelector('input[autocomplete="tel"]');
        FormUtils.setupPhoneMask(phoneInput);
    }
    const bx = () => window.BX;
    const orderComponent = () => window.BX?.Sale?.OrderAjaxComponent;
    const options = () => window.arNextOptions || {};
    const theme = () => options().THEME || {};
    const prices = () => options().PRICES || {};

    const message = (code) => {
        const bitrix = bx();
        return bitrix && typeof bitrix.message === 'function' ? bitrix.message(code) : '';
    };

    const appendHtml = (node, html) => {
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        node.appendChild(template.content);
    };

    const inputByName = (name) => {
        if (!name) {
            return null;
        }

        return Array.from(document.getElementsByName(name)).find((node) => node.tagName === 'INPUT') || null;
    };

    const addRedisignedMarker = (node) => {
        const marker = document.createElement('div');
        marker.className = 'redisigned hidden';
        node.appendChild(marker);
    };

    const addRequiredStar = (input) => {
        const label = input?.closest('.bx-authform-formgroup-container')?.querySelector('.bx-authform-label-container');

        if (label && !label.querySelector('.bx-authform-starrequired')) {
            label.insertAdjacentHTML('beforeend', '<span class="bx-authform-starrequired"> *</span>');
        }
    };

    const wrapFormGroups = (firstInput, secondInput) => {
        const firstGroup = firstInput?.closest('.bx-authform-formgroup-container');
        const secondGroup = secondInput?.closest('.bx-authform-formgroup-container');

        if (!firstGroup || !secondGroup || firstGroup.classList.contains('col-md-6')) {
            return;
        }

        firstGroup.classList.add('col-md-6');
        secondGroup.classList.add('col-md-6');

        const row = document.createElement('div');
        row.className = 'row';

        firstGroup.before(row);
        row.appendChild(firstGroup);
        row.appendChild(secondGroup);
    };

    const addChangeBasket = () => {
        const totals = document.querySelectorAll('.bx-soa-cart-total');

        if (!totals.length || document.querySelector('.change_basket')) {
            return;
        }

        totals.forEach((total) => {
            const block = document.createElement('div');
            block.className = 'change_basket';
            const name = document.createElement('p');
            name.className = 'change_name';
            name.textContent = 'Ваш заказ';
            block.appendChild(name);
            const link = document.createElement('a');
            link.href = `${options().SITE_DIR || '/'}basket/`;
            link.className = 'change_link';
            link.textContent = 'Изменить';

            block.appendChild(link);
            total.prepend(block);
        });
    };

    const updateChangeBasketLink = (component) => {
        if (!component.params) {
            return;
        }

        document.querySelectorAll('.bx-soa-cart-total .change_link').forEach((link) => {
            link.href = component.params.PATH_TO_BASKET;
        });

        if (prices().MIN_PRICE && Number(prices().MIN_PRICE) > Number(component.result?.TOTAL?.ORDER_PRICE)) {
            const fadeMask = document.createElement('div');
            fadeMask.className = 'fademask_ext';
            document.body.appendChild(fadeMask);
            window.location.href = component.params.PATH_TO_BASKET;
        }
    };

    const sendBeginOrderGoal = (component) => {
        if (options().COUNTERS?.USE_FULLORDER_GOALS === 'N' || typeof component.reachgoalbegin !== 'undefined') {
            return;
        }

        component.reachgoalbegin = true;

        if (bx() && typeof bx().onCustomEvent === 'function') {
            bx().onCustomEvent('onCounterGoals', [{goal: 'goal_order_begin'}]);
        }
    };

    const sendCheckoutCounterGoal = (component) => {
        if (component.ecomCheckoutSent) {
            return;
        }

        component.ecomCheckoutSent = true;

        if (typeof window.checkoutCounter === 'function') {
            window.checkoutCounter(1, 'Оформление заказа');
        }
    };

    const updateAuthForm = () => {
        const auth = document.getElementById('bx-soa-auth');

        if (!auth || auth.querySelector('.redisigned')) {
            return;
        }

        addRequiredStar(auth.querySelector('input[name="USER_LOGIN"]'));
        addRequiredStar(auth.querySelector('input[name="USER_PASSWORD"]'));

        const rememberInput = auth.querySelector('input[name="USER_REMEMBER"]');

        if (rememberInput) {
            rememberInput.id = 'ORDER_AUTH_USER_REMEMBER';

            const label = rememberInput.closest('label');

            if (label) {
                const labelText = label.textContent;
                label.setAttribute('for', 'ORDER_AUTH_USER_REMEMBER');
                label.textContent = labelText;
                label.before(rememberInput);
                rememberInput.closest('.bx-authform-formgroup-container')?.classList.add('filter');

                const forgot = auth.querySelector('.bx-authform > a');
                const checkbox = label.closest('.checkbox');

                if (forgot && checkbox) {
                    forgot.classList.add('pull-right', 'forgot');
                    checkbox.before(forgot);
                }
            }
        }

        auth.querySelectorAll('.bx-soa-reg-block .btn').forEach((button) => {
            button.classList.remove('btn-default', 'btn-lg');
            button.classList.add('transparent');
            button.textContent = message('ORDER_REGISTER_BUTTON');
        });

        addRedisignedMarker(auth);
    };

    const bindRegisterSubmit = () => {
        const component = orderComponent();
        const submit = document.querySelector('#do_register~input[type=submit]');

        if (!component || !submit) {
            return;
        }

        if (bx() && typeof bx().unbindAll === 'function') {
            bx().unbindAll(submit);
        }

        submit.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            if (theme().LOGIN_EQUAL_EMAIL === 'Y') {
                const email = document.querySelector('#bx-soa-auth input[name="NEW_EMAIL"]');
                const login = document.querySelector('#bx-soa-auth input[name="NEW_LOGIN"]');

                if (login && email) {
                    login.value = email.value;
                }
            }

            const doRegister = document.getElementById('do_register');

            if (doRegister) {
                doRegister.value = 'Y';
            }

            component.sendRequest('showAuthForm');
        });
    };

    const updateCaptcha = (regContent) => {
        const captcha = regContent.querySelector('.bx-captcha');

        if (!captcha) {
            return;
        }

        captcha.classList.add('captcha_image');
        appendHtml(captcha, '<div class="captcha_reload"></div>');

        const group = captcha.closest('.bx-authform-formgroup-container');
        group?.classList.add('captcha-row');
        group
            ?.querySelector('input[name=captcha_word]')
            ?.closest('.bx-authform-input-container')
            ?.classList.add('captcha_input');
    };

    const updatePhoneInput = (regContent) => {
        const phoneInputs = regContent.querySelectorAll('input[name=PHONE_NUMBER]');

        if (phoneInputs.length !== 1) {
            return;
        }

        const input = phoneInputs[0];
        const telInput = input.cloneNode(true);
        telInput.type = 'tel';
        telInput.value = input.value;

        input.style.display = 'none';
        input.after(telInput);

        if (typeof window.showPhoneMask === 'function') {
            window.showPhoneMask('input[name=PHONE_NUMBER][type=tel]');
        }

        telInput.addEventListener('blur', () => {
            const textInput = telInput.parentNode?.querySelector('input[name=PHONE_NUMBER][type=text]');

            if (textInput) {
                textInput.value = telInput.value;
            }
        });

        const label = telInput
            .closest('.bx-authform-formgroup-container')
            ?.querySelector('.bx-authform-label-container');

        if (label) {
            label.innerHTML =
                message('ORDER_PHONE_LABEL') +
                (label.querySelector('.bx-authform-starrequired')
                    ? '<span class="bx-authform-starrequired"> *</span>'
                    : '');
        }
    };

    const updateRegisterForm = () => {
        const regContent = document.querySelector('.bx-soa-section-content.reg');

        if (!regContent || regContent.querySelector('.redisigned')) {
            return;
        }

        let rebindRegSubmit = false;
        const newLogin = regContent.querySelector('input[name="NEW_LOGIN"]');
        const newName = regContent.querySelector('input[name="NEW_NAME"]');
        const newLastName = regContent.querySelector('input[name="NEW_LAST_NAME"]');
        const newEmail = regContent.querySelector('input[name=NEW_EMAIL]');
        const phoneNumber = regContent.querySelector('input[name=PHONE_NUMBER]');
        const newPassword = regContent.querySelector('input[name=NEW_PASSWORD]');
        const newPasswordConfirm = regContent.querySelector('input[name=NEW_PASSWORD_CONFIRM]');

        if (theme().LOGIN_EQUAL_EMAIL === 'Y') {
            rebindRegSubmit = true;
            newLogin?.closest('.bx-authform-formgroup-container')?.style.setProperty('display', 'none');
        }

        if (theme().PERSONAL_ONEFIO === 'Y') {
            rebindRegSubmit = true;

            const label = newName
                ?.closest('.bx-authform-formgroup-container')
                ?.querySelector('.bx-authform-label-container');

            if (label) {
                label.innerHTML = `${message('ORDER_FIO_LABEL')}<span class="bx-authform-starrequired"> *</span>`;
            }

            newLastName?.closest('.bx-authform-formgroup-container')?.style.setProperty('display', 'none');

            if (newLastName) {
                newLastName.value = ' ';
            }
        }

        if (rebindRegSubmit) {
            bindRegisterSubmit();
        }

        updateCaptcha(regContent);

        if (newName && newLastName && theme().PERSONAL_ONEFIO !== 'Y') {
            wrapFormGroups(newName, newLastName);
        }

        if (newEmail && phoneNumber) {
            wrapFormGroups(newEmail, phoneNumber);
        }

        if (newPassword && newPasswordConfirm) {
            wrapFormGroups(newPassword, newPasswordConfirm);
        }

        updatePhoneInput(regContent);
        addRedisignedMarker(regContent);
    };

    const toggleNamedInput = (name, component, stateKey) => {
        const input = inputByName(name);
        const checked = !input?.checked;

        if (input) {
            input.checked = checked;
        }

        component[stateKey] = checked ? 'checked' : '';
    };

    const bindLicenceClicks = (component, showLicence, showOffer) => {
        if (showLicence && !state.licenceClickBound) {
            state.licenceClickBound = true;

            document.addEventListener('click', (event) => {
                const label = event.target.closest('.bx-soa .licence_block label.license');

                if (!label) {
                    return;
                }

                document.querySelectorAll('.bx-soa .licence_block label.error').forEach((error) => {
                    error.classList.add('hidden');
                });

                toggleNamedInput(label.dataset.for, component, 'state_licence');
            });
        }

        if (showOffer && !state.offerClickBound) {
            state.offerClickBound = true;

            document.addEventListener('click', (event) => {
                const label = event.target.closest('.bx-soa .offer_block label.offer_pub');

                if (!label) {
                    return;
                }

                document.querySelectorAll('.bx-soa .offer_block label.error').forEach((error) => {
                    error.classList.add('hidden');
                });

                toggleNamedInput(label.dataset.for, component, 'state_offer');
            });
        }

        if (!state.licenceConditionClickBound) {
            state.licenceConditionClickBound = true;

            document.addEventListener('click', (event) => {
                const link = event.target.closest('.lic_condition a');

                if (!link) {
                    return;
                }

                const currentComponent = orderComponent();
                const orderNode = document.getElementById('bx-soa-order');

                if (!currentComponent) {
                    return;
                }

                if (bx()?.hasClass?.(orderNode, 'orderform--v1')) {
                    currentComponent.isValidForm?.();
                    return;
                }

                const errors = currentComponent.isValidPropertiesBlock?.() || [];

                if (!currentComponent.activeSectionId || !errors.length) {
                    const target = document.querySelector('.licence_block, .offer_block');
                    currentComponent.animateScrollTo?.(target, 800, 50);
                }
            });
        }
    };

    const renderLicenceBlocks = (component, showLicence, showOffer) => {
        if (typeof component.state_licence === 'undefined') {
            component.state_licence = theme().LICENCE_CHECKED === 'Y' ? 'checked' : '';
        }

        if (typeof component.state_offer === 'undefined') {
            component.state_offer = theme().OFFER_CHECKED === 'Y' ? 'checked' : '';
        }

        if (
            document.querySelector('.bx-soa-auth.bx-active') ||
            ((document.querySelector('.licence_block.filter') || !showLicence) &&
                (document.querySelector('.offer_block.filter') || !showOffer))
        ) {
            return;
        }

        const orderSave = document.getElementById('bx-soa-orderSave');

        if (!orderSave) {
            return;
        }

        const form = document.createElement('div');
        form.className = 'form';

        const wrapper = document.createElement('div');
        wrapper.className = 'license_order_wrap';

        form.appendChild(wrapper);
        orderSave.before(form);

        if (!document.querySelector('.licence_block.filter') && showLicence) {
            appendHtml(
                wrapper,
                `<div class="licence_block filter label_block"><span class="hidden error">${message(
                    'JS_REQUIRED_LICENSES'
                )}</span><input type="checkbox" name="licenses_order" checked required ${
                    component.state_licence
                } value="Y"><span class="license page-text--base">${message('LICENSES_TEXT_ORDER')}</span></div>`
            );
        }

        if (!document.querySelector('.offer_block.filter') && showOffer) {
            appendHtml(
                wrapper,
                `<div class="offer_block filter label_block"><label data-for="offer_order" class="hidden error">${message(
                    'JS_REQUIRED_OFFER'
                )}</label><input type="checkbox" name="offer_order" required ${
                    component.state_offer
                } value="Y"><label data-for="offer_order" class="offer_pub">${message('OFFER_TEXT')}</label></div>`
            );
        }

        bindLicenceClicks(component, showLicence, showOffer);
    };

    const bindBxClick = (node, component) => {
        if (!node || !bx() || typeof bx().bind !== 'function') {
            return;
        }

        if (typeof bx().unbindAll === 'function') {
            bx().unbindAll(node);
        }

        const handler =
            typeof bx().proxy === 'function'
                ? bx().proxy(component.clickOrderSaveAction, component)
                : component.clickOrderSaveAction.bind(component);

        bx().bind(node, 'click', handler);
    };

    const wrapOrderSaveAction = (component) => {
        if (
            typeof component.oldClickOrderSaveAction !== 'undefined' ||
            typeof component.clickOrderSaveAction === 'undefined'
        ) {
            return;
        }

        component.oldClickOrderSaveAction = component.clickOrderSaveAction;

        component.clickOrderSaveAction = function (event) {
            const licenceChecked = inputByName('licenses_order')?.checked || theme().SHOW_LICENCE !== 'Y';
            const offerChecked = inputByName('offer_order')?.checked || theme().SHOW_OFFER !== 'Y';

            if (licenceChecked && offerChecked) {
                document.querySelectorAll('.bx-soa .licence_block label.error').forEach((error) => {
                    error.classList.add('hidden');
                });
                document.querySelectorAll('.bx-soa .offer_block label.error').forEach((error) => {
                    error.classList.add('hidden');
                });

                if (component.isValidForm?.()) {
                    component.allowOrderSave?.();

                    if (typeof component.doSaveAction === 'function') {
                        component.doSaveAction();
                    } else {
                        component.oldClickOrderSaveAction.call(component, event);
                    }
                }

                return;
            }

            if (!inputByName('licenses_order')?.checked) {
                document.querySelectorAll('.bx-soa .licence_block label.error').forEach((error) => {
                    error.classList.remove('hidden');
                });
            }

            if (!inputByName('offer_order')?.checked) {
                document.querySelectorAll('.bx-soa .offer_block label.error').forEach((error) => {
                    error.classList.remove('hidden');
                });
            }
        };

        const checkbox = component.orderSaveBlockNode?.querySelector('.checkbox');

        if (checkbox && typeof window.browser === 'object') {
            checkbox.remove();
        }

        bindBxClick(component.totalInfoBlockNode?.querySelector('a.btn-order-save'), component);
        bindBxClick(component.mobileTotalBlockNode?.querySelector('a.btn-order-save'), component);
        bindBxClick(component.orderSaveBlockNode?.querySelector('a'), component);
    };

    const updateLicenceAndOffer = (component) => {
        const showLicence = theme().SHOW_LICENCE === 'Y';
        const showOffer = theme().SHOW_OFFER === 'Y';

        if (!document.querySelector('.bx-soa-cart-total-line-total') || (!showLicence && !showOffer)) {
            return;
        }

        renderLicenceBlocks(component, showLicence, showOffer);

        document.querySelectorAll('#bx-soa-orderSave, .bx-soa-cart-total-button-container').forEach((node) => {
            node.classList.add('lic_condition');
        });

        wrapOrderSaveAction(component);
    };

    const parseResult = (result) => {
        if (result && typeof result === 'object') {
            return result;
        }

        if (typeof result !== 'string') {
            return null;
        }

        if (bx() && typeof bx().parseJSON === 'function') {
            return bx().parseJSON(result);
        }

        try {
            return JSON.parse(result);
        } catch {
            return null;
        }
    };

    const callOldSaveOrder = (component, result) => {
        component.oldSaveOrder.call(component, result);
    };

    const checkOrderBeforeSave = (component, orderId, result) => {
        fetch(`${options().SITE_DIR || '/'}ajax/check_order.php`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: new URLSearchParams({ID: orderId}),
        })
            .then((response) => response.json())
            .then((id) => {
                const parsedId = parseInt(id, 10);

                if (parsedId && typeof window.purchaseCounter === 'function') {
                    window.purchaseCounter(parsedId, message('FULL_ORDER'), (data) => {
                        if (typeof window.localStorage !== 'undefined' && typeof data === 'object') {
                            window.localStorage.setItem(`gtm_e_${orderId}`, JSON.stringify(data));
                        }

                        callOldSaveOrder(component, result);
                    });
                } else {
                    callOldSaveOrder(component, result);
                }
            })
            .catch(() => {
                callOldSaveOrder(component, result);
            });
    };

    const wrapSaveOrder = (component) => {
        if (
            typeof window.checkCounters !== 'function' ||
            !window.checkCounters() ||
            typeof component.oldSaveOrder !== 'undefined'
        ) {
            return;
        }

        const saveFunc = typeof component.saveOrder !== 'undefined' ? 'saveOrder' : 'saveOrderWithJson';

        if (typeof component[saveFunc] === 'undefined') {
            return;
        }

        component.oldSaveOrder = component[saveFunc];

        component[saveFunc] = function (result) {
            const parsed = parseResult(result);
            const order = parsed?.order;

            if (
                !order ||
                order.SHOW_AUTH ||
                !order.REDIRECT_URL ||
                order.REDIRECT_URL.length < 1 ||
                (order.ERROR && Object.keys(order.ERROR).length)
            ) {
                callOldSaveOrder(component, result);
                return;
            }

            const matches = order.REDIRECT_URL.match(/ORDER_ID=[^&=]*/g);
            const orderId = matches?.length ? matches[0].replace(/ORDER_ID=/g, '') : '';

            if (orderId) {
                checkOrderBeforeSave(component, orderId, result);
            } else {
                callOldSaveOrder(component, result);
            }
        };
    };

    const setupInvisibleCaptcha = (component) => {
        const captchaRows = document.querySelectorAll('#bx-soa-order-form .captcha-row');

        if (!captchaRows.length) {
            return;
        }

        if (
            window.asproRecaptcha &&
            window.asproRecaptcha.key &&
            window.asproRecaptcha.params?.recaptchaSize === 'invisible'
        ) {
            captchaRows.forEach((row) => {
                row.classList.add('invisible');

                if (window.asproRecaptcha.params.recaptchaLogoShow === 'n') {
                    row.classList.add('logo_captcha_n');
                }
            });
        }

        if (
            !document.querySelector('#bx-soa-order-form .captcha-row.invisible') ||
            typeof component.oldSendRequest !== 'undefined' ||
            typeof component.sendRequest === 'undefined'
        ) {
            return;
        }

        let tmpAction;
        let tmpActionData;

        component.oldSendRequest = component.sendRequest;
        component.sendRequest = function (action, actionData) {
            let send = true;

            if (
                document.querySelector('#bx-soa-order-form .captcha-row.invisible') &&
                window.renderRecaptchaById &&
                window.asproRecaptcha &&
                window.asproRecaptcha.key &&
                window.asproRecaptcha.params?.recaptchaSize === 'invisible'
            ) {
                const form = document.getElementById('bx-soa-order-form');
                const recaptcha = form?.querySelector('.g-recaptcha');
                const response = form?.querySelector('.g-recaptcha-response');

                if (recaptcha && !response?.value) {
                    if (typeof window.grecaptcha !== 'undefined') {
                        window.grecaptcha.execute(recaptcha.dataset.widgetid);
                    }

                    send = false;
                }
            }

            if (send) {
                component.oldSendRequest.call(component, action, actionData);
            } else {
                tmpAction = action;
                tmpActionData = actionData;
            }
        };

        if (!state.captchaSubmitHandlerBound) {
            state.captchaSubmitHandlerBound = true;

            document.addEventListener('submit', (event) => {
                if (!event.target.matches('#bx-soa-order-form')) {
                    return;
                }

                event.preventDefault();

                if (typeof tmpAction !== 'undefined' || typeof tmpActionData !== 'undefined') {
                    component.sendRequest(tmpAction, tmpActionData);
                    tmpAction = undefined;
                    tmpActionData = undefined;
                }
            });
        }
    };

    const bindQuickLocations = () => {
        if (state.quickLocationsClickBound) {
            return;
        }

        state.quickLocationsClickBound = true;

        document.addEventListener('click', (event) => {
            const location = event.target.closest('.bx-ui-sls-quick-locations.quick-locations');

            if (!location) {
                return;
            }

            Array.from(location.parentNode?.children || []).forEach((sibling) => {
                if (sibling !== location) {
                    sibling.classList.remove('active');
                }
            });

            location.classList.add('active');
        });
    };

    const runOrderActions = () => {
        if (!options().PAGES?.ORDER_PAGE || !document.querySelector('.bx-soa-cart-total')) {
            return;
        }

        addChangeBasket();

        const component = orderComponent();

        if (component && typeof component === 'object') {
            sendBeginOrderGoal(component);
            sendCheckoutCounterGoal(component);
            updateChangeBasketLink(component);
            updateAuthForm();
            updateRegisterForm();
            updateLicenceAndOffer(component);
            window.dispatchEvent(new Event('scroll'));
            wrapSaveOrder(component);
            setupInvisibleCaptcha(component);
        }

        bindQuickLocations();
    };

    const bindAjaxHandlers = () => {
        if (state.ajaxHandlersBound || !bx() || typeof bx().addCustomEvent !== 'function') {
            return;
        }

        state.ajaxHandlersBound = true;
        bx().addCustomEvent('onAjaxSuccess', runOrderActions);
    };

    const start = () => {
        runOrderActions();
        bindAjaxHandlers();

        if (bx() && typeof bx().ready === 'function') {
            bx().ready(runOrderActions);
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
